module.exports = __webpack_public_path__ + "img/66.e85d1904.png";